(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g-recommendations-new"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendationz');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          yourFunctionAfterContentLoaded()
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendationz');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);
  // Define your function to run after content is loaded
  const yourFunctionAfterContentLoaded = () => {
    if (window.innerWidth <= 786) {
            $('.recomm-slider').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1, 
                dots: false,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 5000
            });   
        } else {
            $('.recomm-slider.is-slider').slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1, 
                dots: false,
                arrows: false,
                autoplay: false,
                autoplaySpeed: 5000
            });   
        }
  }; 

  } catch(e) { console.error(e); }
})();
})();
